<span
  *ngIf="iconStructure !== undefined"
  aria-hidden="false"
  class="mx-5 my-3"
  [ngClass]="iconStructure.iconStyle"
>
  {{ iconStructure.icon }}
</span>
